import cht from './cht'
import en from './en'

const i18n = {
  cht, en,
}

export default i18n